import { WorkoutSelection } from '../../../entities/workout';
import { HomeQuarterZones, IHomeQuarterZoneValidation } from '../../../entities/workoutselection';
import { SessionSequenceStrategyContext } from '../../sessionsequence';
import { IHomeQuarterCalculator } from './ihomequartercalculator';

export class HomeQuarterCalculator implements IHomeQuarterCalculator {
  public static amountOfZonesInQuarter = 4;
  public static amountOfQuartersInAWhole = 3;
  public static quarterTimeInSeconds = 720;

  public calculate(workoutSelection: WorkoutSelection): IHomeQuarterZoneValidation {
    const exerciseSelectionsForActiveZoneNumbers
      = WorkoutSelection.exerciseSelectionsForActiveZoneNumbers(workoutSelection);

    const homeQuarterZones: HomeQuarterZones[] = [];
    let currentIndex = 0;
    try {
      exerciseSelectionsForActiveZoneNumbers.forEach((exerciseSelection) => {
        let homeQuarterZone = homeQuarterZones[currentIndex];
        if (!homeQuarterZone) {
          homeQuarterZone = new HomeQuarterZones(exerciseSelection.zone);
          homeQuarterZones.push(homeQuarterZone);
        }

        const {
          zone,
          format,
          exercise,
          alternateExercise,
          secondAlternateExercise,
          thirdAlternateExercise,
        } = exerciseSelection;
        const sessionSequence = SessionSequenceStrategyContext.getSessionSequence(
          format,
          exercise,
          alternateExercise,
          workoutSelection.gymType,
          secondAlternateExercise,
          thirdAlternateExercise,
          undefined,
          undefined,
          workoutSelection.settings,
        );

        const time = SessionSequenceStrategyContext.calculateTotalSeconds(sessionSequence);
        homeQuarterZone.time += time;

        const overflowInMinutes = (homeQuarterZone.time - HomeQuarterCalculator.quarterTimeInSeconds) / 60;
        if (overflowInMinutes === 0) {
          homeQuarterZone.endZone = zone;
          currentIndex += 1;
        } else if (overflowInMinutes > 0) {
          homeQuarterZone.endZone = zone;
          homeQuarterZone.error = `overflow of ${overflowInMinutes} min`;
          currentIndex += 1;
        }
      });

      return {
        quarters: homeQuarterZones,
        errors: workoutSelection.ignoreHomeQuarterErrorsForTesting ? [] : this.validate(homeQuarterZones),
      };
    } catch (error) {
      return {
        quarters: [],
        errors: [`Error loading quarters: ${error}`],
      };
    }
  }

  public getQuarterForZone = (zone: number, homeQuarterValidation: IHomeQuarterZoneValidation): number => {
    const defaultQuarter = 1;
    const quarterIndex = homeQuarterValidation.quarters.findIndex((quarter) => {
      return zone >= quarter.startZone && zone <= quarter.endZone;
    });

    return quarterIndex < 0 ? defaultQuarter : quarterIndex + 1;
  }

  private validate(homeQuarterZones: HomeQuarterZones[]): string[] {
    const errors = [];

    if (homeQuarterZones.length !== HomeQuarterCalculator.amountOfQuartersInAWhole) {
      errors.push(`Workout does not consist of ${HomeQuarterCalculator.amountOfQuartersInAWhole} quarters`);
    }

    let totalTime = 0;
    let hasStartAndEndZones = true;
    homeQuarterZones.forEach((quarter) => {
      totalTime += quarter.time;

      if (!quarter.startZone || !quarter.endZone) {
        hasStartAndEndZones = false;
      }
    });

    if (!hasStartAndEndZones) {
      errors.push('Not all quarters have a start and end zone');
    }

    const expectedTimeInSeconds
      = HomeQuarterCalculator.quarterTimeInSeconds * HomeQuarterCalculator.amountOfQuartersInAWhole;
    if (totalTime !== expectedTimeInSeconds) {
      errors.push(`Total time of home workout is not ${expectedTimeInSeconds / 60} mins`);
    }

    return errors;
  }
}
